import axios from 'axios'
import { Message } from 'element-ui'
import { removeNewToken } from '@/utils/auth'
// import { getNewToken, removeNewToken, setNewToken } from '@/utils/auth'
// import { refreshToken } from '@/api/login'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 90000, // 请求超时时间
  cache: false

})
// request拦截器
service.interceptors.request.use(config => {
  if (localStorage.getItem('refreshToken')) {
    config.headers['X-Access-Protection'] = localStorage.getItem('refreshToken') // 让每个请求携带自定义token 请根据实际情况自行修改
  }
  return config
},
error => {
  Message({ showClose: true, message: error.message, type: 'error', duration: 3 * 1000 })
  // Promise.reject(new Error('errorMsg'))
})
// respone拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code === 11112 || res.code === 11111) {
      // 出错信息捕捉
      if (res.message !== '' && res.message !== null) {
        Message({ showClose: true, message: res.message, type: 'error', duration: 3 * 1000 })
      }
      localStorage.clear()
      sessionStorage.clear()
      removeNewToken()
      window.location.href = '#/login'
    }
    if (res.code === 500) {
      Message({ showClose: true, message: '服务器出差了，请稍等哦！', type: 'error', duration: 3 * 1000 })
    } else {
      return response
    }
  },
  error => {
    const status = error.response.status
    if (status) {
      switch (status) {
        case 401:
          localStorage.clear()
          sessionStorage.clear()
          removeNewToken()
          window.location.href = '#/login'
          break
      }
    } else {
      Message({ showClose: true, message: '出错啦！', type: 'error', duration: 3 * 1000 })
    }
    return Promise.reject(error)
  }
)
export default service



// WEBPACK FOOTER //
// ./src/utils/requestRefresh.js